import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";
import "core-js";

import $ from "jquery";
import "jquery-serializejson";
import "objectFitPolyfill";
import "regenerator-runtime/runtime";
import svg4everybody from "svg4everybody";
import handleNavigation from "util/navigation";
import Page from "webPage/Page";
import "./focus-within-polyfill";
import QuestionnaireModal from "./modal/QuestionnaireModal";
import "./settings";
import TabsSection from "./TabsSection";
import Gallery from "./webPage/Gallery";
import './util/google-maps';

$(function () {
    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $('html').addClass('ie11');
    }
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    svg4everybody();

    Page.init();

    $('body').on('click', 'a', function (e) {
        //Check that we are not on the questionnaire page
        if (['/apprenticeships/apprentices/questionnaire/', '/apprenticeships/apprentices/questionnaire'].indexOf(window.location.pathname) !== -1) {
            return;
        }
        //Check that the link is to the questionnaire page
        if (['/apprenticeships/apprentices/questionnaire/', '/apprenticeships/apprentices/questionnaire'].indexOf(this.pathname) === -1) {
            return;
        }
        if ($(this).is('.js-retry')) {

            return;
        }
        e.preventDefault();

        let modal = new QuestionnaireModal();
        modal.show();
        return false;
    });

    $('.js-testimonials').each(function () {
        let gallery = new Gallery($(this), {
            itemClass: 'testimonial',
            pipClass: 'pips__btn',
            animationDuration: 400,
        });
        $(gallery.getItems()[0]).addClass('testimonial--active');
    });

    $('.js-file-upload').each(function () {
        let $fileUpload = $(this);

        $fileUpload.on('change', 'input', function (e) {
            let text = 'No file chosen';

            if (this.files.length > 0) {
                text = this.files[0].name;
            }

            $fileUpload.find('.fileupload__text').text(text);
        });
    });

    $('.js-tab-section').each(function () {
        new TabsSection($(this));
    });

    handleNavigation();
});

window.$ = window.jQuery = $;
window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
